import React from "react";
import { Menu } from "lucide-react";

function Header({ title, onMobileMenuToggle }) {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200 py-4 px-4 sm:px-6 relative">
      <div className="flex items-center">
        {/* Mobile Menu Button */}
        <button
          className="md:hidden mr-3 p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
          onClick={onMobileMenuToggle}
          aria-label="Open menu"
        >
          <Menu className="w-5 h-5" />
        </button>

        {/* Page Title */}
        <h1 className="text-lg sm:text-xl font-semibold text-gray-800 truncate">
          {title || "Hospital Admin"}
        </h1>
      </div>
    </header>
  );
}

export default Header;
